import { css } from 'lit';

export const styles = css`:host{--diameter: var(--ig-circular-progress-diameter, 3.375rem);--ig-theme: bootstrap}`;
